const featuredCollectionTabFlex = document.querySelector(".featured-collection-tab-flex");
const featuredCollectionTabTitle = document.querySelectorAll(".featured-collection-tab-title");
const featuredCollectionTabContentBlock  = document.querySelectorAll(".featured-collection-tab-content-block");

featuredCollectionTabFlex.addEventListener("click", function (e) {
     const clicked = e.target.closest(".featured-collection-tab-title");
     if (!clicked) return;
     console.log(clicked);
     featuredCollectionTabTitle.forEach( fctt =>  fctt.classList.remove("featured-collection-tab-title--active") );
     clicked.classList.add("featured-collection-tab-title--active");
     featuredCollectionTabContentBlock.forEach( fctcb =>  fctcb.classList.remove("featured-collection-tab-content--active") );
     document.querySelector(`.featured-collection-tab-content-block--${ clicked.dataset.tab }`).classList.add("featured-collection-tab-content--active");
});